import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI, firmsAPI } from '../api';

export default function AdminPanel() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [pending, setPending] = useState([]);
  const [firms, setFirms] = useState([]);
  const [newFirm, setNewFirm] = useState({ name:'', firm_type:'general' });
  const [msg, setMsg] = useState('');

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 3000); };

  const load = async () => {
    const [uRes, pRes, fRes] = await Promise.all([authAPI.getUsers(), authAPI.getPending(), firmsAPI.getAll()]);
    setUsers(uRes.data); setPending(pRes.data); setFirms(fRes.data);
  };

  useEffect(() => { load(); }, []);

  const approve = async (id) => { await authAPI.approveUser(id); load(); flash('Kullanıcı onaylandı.'); };
  const reject = async (id) => { await authAPI.rejectUser(id); load(); flash('Kullanıcı reddedildi.'); };
  const createFirm = async (e) => {
    e.preventDefault();
    await firmsAPI.create(newFirm);
    setNewFirm({ name:'', firm_type:'general' });
    load(); flash('Firma eklendi.');
  };
  const deleteFirm = async (id) => {
    if (!window.confirm('Firmayı silmek istiyor musunuz? Tüm veriler silinecek!')) return;
    await firmsAPI.delete(id); load(); flash('Firma silindi.');
  };

  if (user?.role !== 'admin') return <div style={{padding:'2rem',color:'var(--text3)',textAlign:'center'}}>Erişim yetkiniz yok.</div>;

  const inp = { height:34, padding:'0 10px', border:'1px solid var(--border)', borderRadius:'var(--radius)', fontSize:13, background:'var(--bg2)', color:'var(--text)' };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      {msg && <div style={{padding:'8px 14px',borderRadius:'var(--radius)',background:'var(--green-bg)',color:'var(--green)',border:'1px solid var(--green-border)',fontSize:13}}>✓ {msg}</div>}

      {/* Bekleyen kullanıcılar */}
      {pending.length > 0 && (
        <div className="card">
          <div style={{fontSize:14,fontWeight:600,marginBottom:12,color:'var(--yellow-text)'}}>⏳ Onay Bekleyen ({pending.length})</div>
          {pending.map(u => (
            <div key={u.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid var(--border2)'}}>
              <div style={{fontSize:13,fontWeight:500}}>{u.username}</div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={() => approve(u.id)} className="btn btn-green btn-sm">Onayla</button>
                <button onClick={() => reject(u.id)} className="btn btn-sm" style={{background:'var(--red-bg)',color:'var(--red)',border:'1px solid var(--red-border)'}}>Reddet</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Kullanıcılar */}
      <div className="card">
        <div style={{fontSize:14,fontWeight:600,marginBottom:12}}>Kullanıcılar</div>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
          <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
            {['Kullanıcı','Rol','Durum'].map(h=><th key={h} style={{padding:'6px 0',fontSize:10,color:'var(--text3)',fontWeight:500,textAlign:'left',textTransform:'uppercase'}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id} style={{borderBottom:'1px solid var(--border2)'}}>
                <td style={{padding:'10px 0',fontWeight:500}}>{u.username}</td>
                <td style={{padding:'10px 0'}}><span className={`badge ${u.role==='admin'?'badge-yellow':'badge-blue'}`}>{u.role}</span></td>
                <td style={{padding:'10px 0'}}><span className={`badge ${u.approved?'badge-green':'badge-gray'}`}>{u.approved?'Aktif':'Bekliyor'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Firmalar */}
      <div className="card">
        <div style={{fontSize:14,fontWeight:600,marginBottom:12}}>Firmalar</div>
        <form onSubmit={createFirm} style={{display:'flex',gap:8,marginBottom:14}}>
          <input value={newFirm.name} onChange={e=>setNewFirm(f=>({...f,name:e.target.value}))} placeholder="Firma adı..." style={{...inp,flex:1}} required/>
          <select value={newFirm.firm_type} onChange={e=>setNewFirm(f=>({...f,firm_type:e.target.value}))} style={{...inp,width:150}}>
            <option value="general">Genel</option>
            <option value="agency">Turizm Acentesi</option>
            <option value="hotel">Otel</option>
          </select>
          <button type="submit" className="btn btn-dark">+ Ekle</button>
        </form>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
          <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
            {['Firma','Tür',''].map(h=><th key={h} style={{padding:'6px 0',fontSize:10,color:'var(--text3)',fontWeight:500,textAlign:'left',textTransform:'uppercase'}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {firms.map(f=>(
              <tr key={f.id} style={{borderBottom:'1px solid var(--border2)'}}>
                <td style={{padding:'10px 0',fontWeight:500}}>{f.name}</td>
                <td style={{padding:'10px 0'}}><span className="badge badge-gray">{f.firm_type}</span></td>
                <td style={{padding:'10px 0',textAlign:'right'}}><button onClick={()=>deleteFirm(f.id)} className="btn btn-sm" style={{background:'var(--red-bg)',color:'var(--red)',border:'1px solid var(--red-border)'}}>Sil</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
